"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var elog = require("../../elog");
var sanitized_render_1 = require("../../components/sanitized_render");
var url_helpers_1 = require("../../url_helpers");
var VIMEO = 'vimeo';
var COMPONENT_NAME = 'VideoEmbed';
var VideoEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(VideoEmbed, _super);
    function VideoEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoEmbed.prototype.url = function () {
        var slug = this.props.slug;
        if (this.props.platform === VIMEO) {
            return url_helpers_1.VIMEO_VIDEO.expand({ slug: slug });
        }
        return url_helpers_1.YOUTUBE_VIDEO.expand({ slug: slug });
    };
    VideoEmbed.prototype.render = function () {
        if (!this.props.slug)
            return null;
        try {
            var classes = classNames('video-embed', { 'video-embed--narrow': this.props.narrow }, { 'video-embed--with-description': !!this.props.descriptionHtml }, { 'video-embed--with-background': this.props.withBackground });
            return (React.createElement("div", { className: classes },
                React.createElement("div", { className: "video-embed__wrapper" },
                    React.createElement("div", { className: "video-embed__overhang" },
                        React.createElement("div", { className: "video-embed__columns" },
                            React.createElement("div", { className: "video-embed__column" },
                                React.createElement("div", { className: "video-embed__inner" },
                                    React.createElement("iframe", { title: this.props.caption || this.props.captionHtml, src: this.url(), frameBorder: "0", allowFullScreen: true }))),
                            React.createElement("div", { className: "video-embed__column" },
                                React.createElement(sanitized_render_1.default, { className: "video-embed__caption", html: this.props.captionHtml || this.props.caption, htmlTag: "div" }),
                                React.createElement(sanitized_render_1.default, { className: "video-embed__description", html: this.props.descriptionHtml || this.props.description, htmlTag: "div" })))))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    return VideoEmbed;
}(React.Component));
exports.default = VideoEmbed;
//# sourceMappingURL=video_embed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/video_embed.js
// module id = Sy1L
// module chunks = 0 2 6 20